import React, { Component } from 'react';
import './styles.css';
import { Dialog, SimpleMarkdown } from '../../atoms';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {String} [example]
 * @prop {Boolean} [visible]
 * @prop {Function} [onClose]
 *
 * @augments {Component<Props>}
 */
export default class TermsDialog extends Component {

	state = {
		isVisible: this.props.visible,
	}

	componentDidUpdate (prevProps) {
		if (this.props.visible !== prevProps.visible) {
			this.setState({ isVisible: this.props.visible }); // eslint-disable-line react/no-did-update-set-state
		}
	}

	handleClose = () => {
		this.setState({ isVisible: false });
	}

	render () {
		return (
			<Dialog className='TermsDialog' onClose={this.props.onClose} visible={this.state.isVisible}>
				<button className='TermsDialog-button' onClick={this.handleClose} type='button' />
				<SimpleMarkdown extended={true}>
					{this.props.children}
				</SimpleMarkdown>
			</Dialog>
		);
	}

}




// WEBPACK FOOTER //
// ./src/components/molecules/TermsDialog/TermsDialog.js